import * as TooltipPrimitive from "@radix-ui/react-tooltip"

/**
 * Single Radix Arrow: even isosceles fill + open-path stroke on the two slants only
 * (no base stroke, so Content border join stays clean).
 */
export function TooltipBorderedArrow({
  fillClassName = "fill-ui-bg-elevated",
  borderClassName = "stroke-ui-border-opaque",
}: {
  fillClassName?: string
  borderClassName?: string
}) {
  return (
    <TooltipPrimitive.Arrow asChild width={9} height={5}>
      <svg
        width={9}
        height={5}
        viewBox="0 0 30 10"
        preserveAspectRatio="none"
        overflow="visible"
        className="block -translate-y-px"
      >
        {/* same tip/slants; base past y=0 covers Content border */}
        <polygon points="0,-3 30,-3 15,10" className={fillClassName} />
        {/* open path = two even slants only */}
        <path
          d="M0 0 L15 10 L30 0"
          fill="none"
          strokeWidth={1}
          strokeLinejoin="miter"
          vectorEffect="non-scaling-stroke"
          className={borderClassName}
        />
      </svg>
    </TooltipPrimitive.Arrow>
  )
}
